module.exports = __webpack_public_path__ + "static/img/samsung-svc.de608a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/samsung-svc.jpg
// module id = CQfu
// module chunks = 0